import { render } from "./LeftSidebarLayout.vue?vue&type=template&id=387fc195"
import script from "./LeftSidebarLayout.vue?vue&type=script&lang=js"
export * from "./LeftSidebarLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/student-package/LeftSidebarLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "387fc195"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('387fc195', __exports__)) {
    api.reload('387fc195', __exports__)
  }
  
  module.hot.accept("./LeftSidebarLayout.vue?vue&type=template&id=387fc195", () => {
    api.rerender('387fc195', render)
  })

}


export default __exports__